module.exports = __webpack_public_path__ + "img/success-icon_140_140.63a648b3.png";